import * as Yup from "yup";

const translationSchema = Yup.object().shape({
  language: Yup.string().required("Language is required"),
  content: Yup.string().required("Translation content is required"),
});

const missingTransmissionsSchema = Yup.object().shape({
  active: Yup.boolean(),
  transmissionCycle: Yup.string().when("active", {
    is: true,
    then: (schema) => schema.required("Transmission cycle is required"),
    otherwise: (schema) => schema.nullable(),
  }),
  useSavedNextSendCycle: Yup.boolean(),
});

export const letterTemplateValidationSchema = Yup.object().shape({
  templateName: Yup.string()
    .trim()
    .required("Template name is required")
    .max(75, "Template name cannot exceed 75 characters"),
  accounts: Yup.array().of(Yup.string()),
  showBattery: Yup.boolean(),
  customNextSend: Yup.boolean(),
  associatedDevices: Yup.string(),
  missingTransmissions: missingTransmissionsSchema,
  primaryTemplate: Yup.string()
    .trim()
    .required("Primary template content is required"),
  translations: Yup.array()
    .of(translationSchema)
    .test(
      "unique-languages",
      "Each language can only be used once",
      function (translations) {
        if (!translations || translations.length === 0) return true;
        const languages = translations.map((t) => t.language).filter(Boolean);
        const uniqueLanguages = new Set(languages);
        return languages.length === uniqueLanguages.size;
      }
    ),
});
